webpackJsonp([137436258376382],{

/***/ 2092:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"VisitsReportItemEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"VisitsReportItem","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-visits-report-item-edge-0bc35b6b00af92625115.js